module.exports = {
  MEMBER_POOL_STORAGE_EDIT_REQUEST: 'MEMBER_POOL_STORAGE_EDIT_REQUEST',
  MEMBER_POOL_STORAGE_EDIT_SUCCESS: 'MEMBER_POOL_STORAGE_EDIT_SUCCESS',
  MEMBER_POOL_STORAGE_EDIT_FAILURE: 'MEMBER_POOL_STORAGE_EDIT_FAILURE',
};
